import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";

type Props = {
	value: string;
	onChange: Function;
	disabled?: boolean;
};

const optionTexts: { [key: string]: string } = {
	O: "OK",
	W: "Warning",
	A: "Alert",
};

export const OptionTypePicker = ({ value, onChange, disabled }: Props) => (
	<TextField
		select
		label="Option Type"
		variant="outlined"
		fullWidth
		margin="dense"
		disabled={!!disabled}
		value={value ?? ""}
		onChange={onChange as any}
		slotProps={{ inputLabel: { shrink: true } }}
	>
		{Object.entries(optionTexts).map(([code, text]) => (
			<MenuItem key={`option-${code}`} value={code}>
				{text}
			</MenuItem>
		))}
	</TextField>
);
